module.exports = __webpack_public_path__ + "img/MA-HMI-11.e7ed42cb.png";